/**
 * Socket.io context for real-time updates
 */
import type { Socket } from 'socket.io-client'
import * as React from 'react'

export interface SocketContextType {
  socket: Socket | null
  isConnected: boolean
  connectionError: string | null
}

export const SocketContext = React.createContext<SocketContextType | undefined>(undefined)
